// UI-level Google Campaign Type choice. Mapped to `platform_overrides.google.campaign_type`
// ('DISPLAY'|'VIDEO_CONVERSIONS') only at the request-building boundary, not here.
export const GoogleCampaignType = Object.freeze({
  display: 'display',
  demandGen: 'demandGen',
})

export const DEFAULT_GOOGLE_CAMPAIGN_TYPE = GoogleCampaignType.demandGen

const API_CAMPAIGN_TYPE_BY_UI_TYPE = {
  [GoogleCampaignType.display]: 'DISPLAY',
  [GoogleCampaignType.demandGen]: 'VIDEO_CONVERSIONS',
}

const UI_TYPE_BY_API_CAMPAIGN_TYPE = {
  DISPLAY: GoogleCampaignType.display,
  VIDEO_CONVERSIONS: GoogleCampaignType.demandGen,
}

export function toApiCampaignType(campaignType) {
  return API_CAMPAIGN_TYPE_BY_UI_TYPE[campaignType]
}

// Google's first-headline character cap differs by campaign type: Demand Gen
// allows 40, Display only 30. Shared by the input's maxLength, the
// InfoMessage copy, validateCreative, and the platform-switch truncation in
// CampaignSetup.jsx so all four stay in sync with each other.
const GOOGLE_FIRST_HEADLINE_CHAR_LIMIT_BY_CAMPAIGN_TYPE = {
  [GoogleCampaignType.demandGen]: 40,
  [GoogleCampaignType.display]: 30,
}

export function googleFirstHeadlineCharLimit(campaignType) {
  return (
    GOOGLE_FIRST_HEADLINE_CHAR_LIMIT_BY_CAMPAIGN_TYPE[campaignType] ??
    GOOGLE_FIRST_HEADLINE_CHAR_LIMIT_BY_CAMPAIGN_TYPE[DEFAULT_GOOGLE_CAMPAIGN_TYPE]
  )
}

export function deriveCampaignTypeFromSetup(setup) {
  const apiValue = setup?.platform_overrides?.google?.campaign_type
  return UI_TYPE_BY_API_CAMPAIGN_TYPE[apiValue] ?? DEFAULT_GOOGLE_CAMPAIGN_TYPE
}
